import React from 'react';
import { planingimg1 } from '../assets/images';

/* Blueprint canvas — architectural drawing in brand green palette */
function drawBlueprint(canvas) {
  const ctx = canvas.getContext('2d'), w = canvas.width, h = canvas.height;

  /* Deep forest green background */
  ctx.fillStyle = '#0A1A10';
  ctx.fillRect(0, 0, w, h);

  /* Fine grid overlay */
  const gs = 30;
  ctx.strokeStyle = 'rgba(30,40,35,0.07)'; ctx.lineWidth = 0.5;
  for (let x = 0; x < w; x += gs) { ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h); ctx.stroke(); }
  for (let y = 0; y < h; y += gs) { ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke(); }

  const bx = 80, by = 120, bw = 440, bh = 480;

  /* Main building outline */
  ctx.strokeStyle = 'rgba(30,40,35,0.6)'; ctx.lineWidth = 1.5;
  ctx.beginPath(); ctx.rect(bx, by, bw, bh); ctx.stroke();

  /* Floor lines */
  for (let i = 1; i < 8; i++) {
    const fy = by + i * (bh / 8);
    ctx.beginPath(); ctx.moveTo(bx, fy); ctx.lineTo(bx + bw, fy);
    ctx.strokeStyle = 'rgba(30,40,35,0.2)'; ctx.lineWidth = 0.8; ctx.stroke();
  }

  /* Column lines */
  for (let i = 1; i < 4; i++) {
    const cx2 = bx + i * (bw / 4);
    ctx.beginPath(); ctx.moveTo(cx2, by); ctx.lineTo(cx2, by + bh);
    ctx.strokeStyle = 'rgba(30,40,35,0.3)'; ctx.lineWidth = 1; ctx.stroke();
  }

  /* Windows */
  ctx.fillStyle = 'rgba(30,40,35,0.12)';
  for (let r = 0; r < 7; r++) {
    for (let c = 0; c < 4; c++) {
      const wx = bx + c * (bw / 4) + 20, wy = by + (r + 1) * (bh / 8) + 10;
      ctx.fillRect(wx, wy, 70, 30);
      ctx.strokeStyle = 'rgba(30,40,35,0.4)'; ctx.lineWidth = 0.8;
      ctx.strokeRect(wx, wy, 70, 30);
    }
  }

  /* Ground floor — double-height entrance */
  ctx.fillStyle = 'rgba(30,40,35,0.06)';
  ctx.fillRect(bx + bw * 0.35, by + bh - bh / 8, bw * 0.3, bh / 8);
  ctx.strokeStyle = 'rgba(30,40,35,0.45)'; ctx.lineWidth = 1;
  ctx.strokeRect(bx + bw * 0.35, by + bh - bh / 8, bw * 0.3, bh / 8);

  /* Rooftop spire */
  ctx.strokeStyle = 'rgba(30,40,35,0.5)'; ctx.lineWidth = 1.5;
  ctx.beginPath(); ctx.moveTo(bx + bw / 2, by - 80); ctx.lineTo(bx + bw / 2, by); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(bx + bw / 2 - 60, by - 40); ctx.lineTo(bx + bw / 2 + 60, by - 40); ctx.stroke();

  /* Cross-hatch roof detail */
  ctx.strokeStyle = 'rgba(30,40,35,0.15)'; ctx.lineWidth = 0.5;
  for (let i = 0; i < 8; i++) {
    ctx.beginPath();
    ctx.moveTo(bx + bw / 2 - 60 + i * 15, by - 40);
    ctx.lineTo(bx + bw / 2 - 55 + i * 15, by);
    ctx.stroke();
  }

  /* Dimension line */
  ctx.strokeStyle = 'rgba(30,40,35,0.3)'; ctx.setLineDash([4, 4]); ctx.lineWidth = 0.8;
  ctx.beginPath(); ctx.moveTo(bx - 30, by); ctx.lineTo(bx - 30, by + bh); ctx.stroke();
  ctx.beginPath();
  ctx.moveTo(bx - 35, by); ctx.lineTo(bx - 25, by);
  ctx.moveTo(bx - 35, by + bh); ctx.lineTo(bx - 25, by + bh);
  ctx.stroke();
  ctx.setLineDash([]);

  /* Labels */
  ctx.fillStyle = 'rgba(30,40,35,0.7)';
  ctx.font = '11px monospace'; ctx.textAlign = 'center';
  ctx.fillText('MUSTER CONSTRUCT', w / 2, by - 90);
  ctx.fillText('RESIDENTIAL · COMMERCIAL · TENSILE · PEB', w / 2, by - 73);
  ctx.font = '9px monospace'; ctx.textAlign = 'right';
  ctx.fillText('SALEM & COIMBATORE', bx - 38, (by + by + bh) / 2);
}

export default function About() {
  const pillars = [
    ['Safety First', 'Zero-compromise safety protocols on every site, every single day.'],
    ['On Schedule', 'Strict milestone tracking for on-time delivery on every project.'],
    ['Quality Build', 'Premium materials and certified contractors — no shortcuts taken.'],
    ['Transparent', 'Itemised cost statements and real-time progress updates always.'],
  ];

  return (
    <section id="about" style={{ position: 'relative', zIndex: 1, padding: '7rem 2rem', background: 'rgba(250,250,250,0.84)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="about-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5rem', alignItems: 'center' }}>

          {/* Blueprint visual */}
          <div style={{ position: 'relative' }} className="reveal-left">
            <div style={{ position: 'relative', aspectRatio: '4/5', background: 'var(--mid)', overflow: 'hidden' }}>
              <div style={{
                position: 'absolute', inset: 0,
                background: 'linear-gradient(135deg,rgba(30,40,35,0.1),transparent)', zIndex: 1
              }} />
              <img
                src={planingimg1}
                alt="Planning blueprint"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            {/* Gold badge */}
            <div style={{
              position: 'absolute', bottom: '-1.5rem', right: '-1.5rem',
              background: 'var(--gold)', padding: '1.5rem', textAlign: 'center', zIndex: 2
            }}>
              <div style={{ fontFamily: 'var(--fh)', fontSize: '2.2rem', fontWeight: 800, color: 'var(--dk)', lineHeight: 1 }}>2.5Lakh</div>
              <div style={{
                fontFamily: 'var(--fh)', fontSize: '0.7rem', fontWeight: 600,
                letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--dk)', lineHeight: 1.3
              }}>
                Affordable Price<br />Onwards
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="reveal-right">
            <p style={{
              fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 600,
              letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1rem'
            }}>
              About Muster Construct
            </p>
            <h2 style={{
              fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
              textTransform: 'uppercase', lineHeight: 1, marginBottom: '1.5rem'
            }}>
              Turn Your Dream House<br />
              <span style={{ color: 'var(--gold)' }}>Into Reality</span>
            </h2>
            <p style={{ fontSize: '1.05rem', fontWeight: 500, lineHeight: 1.8, color: 'var(--lt)', marginBottom: '1.5rem' }}>
              Muster Construct & Consultancy Services is a leading construction firm operating across Salem and Coimbatore, Tamil Nadu. Founded by <strong style={{ color: 'var(--wh)', fontWeight: 500 }}>Karthikeyan.R BE (Proprietor)</strong>, we bring deep engineering expertise to every project — from single homes to large commercial complexes.
            </p>
            <p style={{ fontSize: '1.05rem', fontWeight: 500, lineHeight: 1.8, color: 'var(--lt)', marginBottom: '2rem' }}>
              We specialise in residential buildings, commercial structures, tensile canopies, and pre-engineered buildings — delivering quality construction starting from just 2.5Lakh Affordable Price.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              {pillars.map(([title, desc]) => (
                <div key={title} style={{ borderLeft: '2px solid var(--gold)', paddingLeft: '1rem' }}>
                  <div style={{
                    fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 700,
                    letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--wh)', marginBottom: '0.25rem'
                  }}>
                    {title}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--muted)', lineHeight: 1.5, fontWeight: 500 }}>{desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <style>{`@media(max-width:900px){.about-grid{grid-template-columns:1fr!important}}`}</style>
    </section>
  );
}
